const styles = () => ({
    positionRelative: {
        position: 'relative',
    },
    circularProgress: {
        position: 'absolute',
        top: '35px',
        right: '20px',
    },
});

export default styles;
